export default __webpack_public_path__ + "static/spline-222b04fe75a4539be017e3baa0e8c839.gif";